import styles from "./index.module.css";

const PriceWithShelf = ({
  display,
  shelf,
  nativeCurrency,
  showShelf = false,
  fxLabel,
  hasPromo = false,
  className = "",
  prefix = "",
}) => (
  <span
    className={`${styles.wrapper} ${
      hasPromo ? styles.hasPromo : styles.noPromo
    } ${className}`}
  >
    <span className={styles.display}>
      {prefix}
      {display}
    </span>
    {showShelf && shelf != null && shelf !== "-" && (
      <span
        className={styles.shelf}
        title={`Original price in ${nativeCurrency || "source currency"}`}
      >
        (OG: {prefix}
        {shelf}
        {nativeCurrency ? ` ${nativeCurrency}` : ""})
      </span>
    )}
    {fxLabel && (
      <span className={styles.fxRate} title="Source currency to selected currency">
        {fxLabel}
      </span>
    )}
  </span>
);

export default PriceWithShelf;
